import { mac, commandKeySymbol, optionsKeySymbol } from 'common/ProseInput/Keymap'
import Styles from './KeyboardShortcutTag.module.scss'
import cx from 'classnames'

type ModifierKey = 'Mod' | 'Shift' | 'Opt'
type ModifierMap = {
  [K in ModifierKey]: string
}

const modifierMap: ModifierMap = {
  Mod: commandKeySymbol(),
  Shift: '⇧',
  Opt: optionsKeySymbol(),
}

export interface KeyboardShortcutTagProps {
  modifiers: ModifierKey[]
  keys: string
  className?: string
  prefix?: string
  size?: 'sm' | 'md'
}

export const KeyboardShortcutTag = ({ modifiers, keys, className, prefix, size = 'md' }: KeyboardShortcutTagProps) => {
  const separator = mac ? '' : '+'
  const modifierStrings = modifiers.map((modifier) => modifierMap[modifier])
  const shortcut = [...modifierStrings, ...keys].join(separator).toUpperCase()

  return <kbd className={cx(Styles.shortcut, className, Styles[size])}>{[prefix, shortcut].join(separator)}</kbd>
}
